import { render, staticRenderFns } from "./ConstituicaoMatriz.vue?vue&type=template&id=fef0ecb6&"
import script from "./ConstituicaoMatriz.vue?vue&type=script&lang=js&"
export * from "./ConstituicaoMatriz.vue?vue&type=script&lang=js&"
import style0 from "./ConstituicaoMatriz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports